import { render } from "./Suggestion.vue?vue&type=template&id=647fe2eb"
import script from "./Suggestion.vue?vue&type=script&lang=js"
export * from "./Suggestion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__